import React from "react";
import { Rocket, Mail, CheckCircle2 } from "lucide-react";
import StorefrontHeader from "../components/StorefrontHeader";
import { StorefrontList } from "./Storefront";
import useEmbedResize from "../hooks/useEmbedResize";

/**
 * Format hub: solo vote-to-launch products (one product, one threshold).
 * Reuses the existing StorefrontList component for the grid+voting UI.
 */
export default function StorefrontLaunches() {
  useEmbedResize();
  return (
    <div className="dc-store min-h-screen" data-testid="storefront-launches-page">
      <StorefrontHeader active="launches" />

      <div className="max-w-6xl mx-auto px-6 md:px-10 pt-10 md:pt-16 pb-2">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-widest text-[#5B4FE0] font-semibold">
            <Rocket size={12} /> Solo launches
          </div>
          <h1 className="text-3xl sm:text-5xl font-semibold tracking-tight mt-3 leading-tight text-[#111]">
            Vote to launch.
          </h1>
          <p className="text-base sm:text-lg text-[#6D7175] mt-4 leading-relaxed">
            Every product has its own vote goal. When enough people back it, we launch it — no head-to-head, no eliminations.
            Just a transparent threshold and a clear pre-order date.
          </p>
          <div className="mt-6 flex items-center gap-4 text-xs text-[#6D7175] flex-wrap">
            <span className="inline-flex items-center gap-1.5"><Mail size={12} /> One vote per email per product</span>
            <span className="inline-flex items-center gap-1.5"><CheckCircle2 size={12} className="text-[#5B4FE0]" /> Auto-flips to pre-order at threshold</span>
          </div>
        </div>
      </div>

      {/* Reuse the existing grid + email + voting UI — voting-only (pre-orders live on /storefront/preorders) */}
      <div className="-mt-2" data-testid="launches-list">
        <StorefrontList statusFilter="voting" />
      </div>
    </div>
  );
}
